import { registerSessionCacheClearHandler } from '../../shared/ports/sessionResetPort';
import { clearStorefrontStatusCaches } from './storefrontStatusCache';

registerSessionCacheClearHandler(() => {
  clearStorefrontStatusCaches();
});
